var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-navbar',[_c('f7-nav-left',[_c('f7-link',{attrs:{"panel-open":"left"}},[_c('i',{staticClass:"f7-icons"},[_vm._v("menu")])])],1),_c('f7-nav-title',[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }